import { useEffect, useState } from 'react';

export const useResendCodeTimer = () => {
  const [remainingTimeToSendCode, setRemainingTimeToSendCode] = useState<number>(60);

  useEffect(() => {
    if (remainingTimeToSendCode > 0) {
      const timer = setInterval(() => {
        setRemainingTimeToSendCode(remainingTimeToSendCode > 0 ? remainingTimeToSendCode - 1 : 0);
      }, 1000);

      return () => {
        return clearInterval(timer);
      };
    }

    return () => {};

    /* return () => {
      dispatch(setDefaultRemainingTimeToSendCode(0));
    }; */
  }, [remainingTimeToSendCode]);

  return {
    remainingTimeToSendCode,
    setRemainingTimeToSendCode,
  };
};
